<template>
  <v-layout>
    <v-flex xs12>
      <v-flex text-xs-center>
        <h1 class="halfwhite-text text-uppercase">
          Recent Ovation Activity
          <span class="caption"
            >Last Refreshed At:
            {{ lastRefreshAt | moment("YYYY/MM/DD h:mm a") }}</span
          >
        </h1>
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="secondary"
        ></v-progress-circular>
      </v-flex>

      <v-flex
        text-xs-center
        mt-2
        v-if="!loading && recentActivities.length == 0"
      >
        <h2 class="halfwhite-text font-weight-medium">
          No activity to display
        </h2>
      </v-flex>

      <v-container grid-list-md fluid>
        <v-layout row wrap>
          <v-flex
            d-flex
            v-for="(activityItem, index) in recentActivities"
            :key="index"
            md4
          >
            <v-card
              tile
              max-width="400px"
              max-height="230px"
              height="230px"
              class="rounded"
            >
              <v-img height="230px" :src="getActivityImage(activityItem)">
                <v-container fill-height fluid pa-2>
                  <v-layout fill-height>
                    <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex style="flex-grow: 0">
                          <v-chip
                            outline
                            class="font-weight-black"
                            :text-color="getActivityColor(activityItem)"
                            :title="
                              'Sender: ' +
                              activityItem.sourceUser.firstname +
                              ' ' +
                              activityItem.sourceUser.lastname
                            "
                          >
                            <v-avatar :color="getActivityColor(activityItem)">
                              <img
                                style="padding: 2px"
                                v-if="
                                  (activityItem.sourceUser || {}).isavatarlocal
                                "
                                :src="
                                  (activityItem.sourceUser || {}).avatarlocal
                                "
                              />
                              <span v-else class="white--text">{{
                                activityItem.sourceUser.firstname
                                  .charAt(0)
                                  .toUpperCase() +
                                activityItem.sourceUser.lastname
                                  .charAt(0)
                                  .toUpperCase()
                              }}</span>
                            </v-avatar>
                            <!-- <v-icon>mdi-coins</v-icon> -->
                            <img
                              class="mr-2"
                              src="https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/favicon-32x32.png"
                              alt="Ovation"
                              style="width: 18px"
                            />
                            <span class="font-weight-bold"
                              >-{{ toggleAmount(activityItem) }}</span
                            >
                          </v-chip>
                        </v-flex>
                        <v-flex style="flex-grow: 0">
                          <div class="mt-2">
                            <v-icon color="secondary">arrow_forward_ios</v-icon>
                          </div>
                        </v-flex>
                        <v-flex style="flex-grow: 0">
                          <v-chip
                            outline
                            class="font-weight-black"
                            text-color="#e0922f"
                            :title="
                              'Receiver: ' +
                              activityItem.targetUser.firstname +
                              ' ' +
                              activityItem.targetUser.lastname
                            "
                          >
                            <v-avatar color="#e0922f">
                              <img
                                style="padding: 2px"
                                v-if="
                                  (activityItem.targetUser || {}).isavatarlocal
                                "
                                :src="
                                  (activityItem.targetUser || {}).avatarlocal
                                "
                              />
                              <span v-else class="white--text">{{
                                activityItem.targetUser.firstname
                                  .charAt(0)
                                  .toUpperCase() +
                                activityItem.targetUser.lastname
                                  .charAt(0)
                                  .toUpperCase()
                              }}</span>
                            </v-avatar>
                            <!-- <v-icon>mdi-coins</v-icon> -->
                            <img
                              class="mr-2"
                              src="https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/favicon-32x32.png"
                              alt="Ovation"
                              style="width: 18px"
                            />
                            <span class="font-weight-bold"
                              >+{{ toggleAmount(activityItem) }}</span
                            >
                          </v-chip>
                        </v-flex>
                        <v-flex text-xs-right mt-2>
                          <span class="font-weight-medium">{{
                            activityItem.date | moment("YYYY/MM/DD")
                          }}</span>
                        </v-flex>
                        <v-flex text-xs-right mt-2>
                          <span v-html="getActivityIcon(activityItem)"></span>
                        </v-flex>
                      </v-layout>
                      <v-layout mt-2 row wrap>
                        <v-flex>
                          <div
                            class="subheading font-weight-bold"
                            style="max-width: 385px"
                          >
                            {{ activityItem.message }}
                          </div>
                          <div class="mt-2 body-2" style="max-width: 385px">
                            <div
                              v-html="activityItem.description"
                              class="recent-dashboard-media-preview"
                            ></div>
                          </div>
                        </v-flex>
                      </v-layout>
                      <!-- <v-layout row wrap>
                        <v-flex text-xs-right>
                          <span class="font-weight-medium">{{
                            activityItem.date
                              | moment("dddd, MMMM DD, YYYY, h:mm a")
                          }}</span>
                        </v-flex>
                      </v-layout> -->
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>
            </v-card>
            <v-flex xs1 text-xs-center d-flex>
              <v-icon text-xs-center color="secondary">mdi-arrow-right</v-icon>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "RecentActivityDashboard",
  data() {
    return {
      loading: false,
      recentActivities: [],
      polling: null,
      lastRefreshAt: new Date(),
    };
  },
  methods: {
    loadRecentActivities: function () {
      if (!this.$route.query.token || this.$route.query.token === "") {
        this.$store.commit("replaceSnackbar", {
          message:
            "Request token is empty or missing, please contact org admin",
          messageType: "warning",
        });

        return false;
      }
      this.loading = true;

      axios
        .get(
          "/api/org/activity/" +
            this.$route.params.org_id +
            "/" +
            this.$route.query.token,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.recentActivities = response.data;
          this.lastRefreshAt = new Date();
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error in loading Recent Activity.<br />Server Response: " +
              e.response.data.message,
            messageType: "error",
          });
        });
      if (!this.polling)
        this.polling = setInterval(this.loadRecentActivities, 1000 * 60 * 30);
    },
    toggleAmount(activity) {
      if (!(activity.transaction || {}).isPrivate)
        return (activity.transaction || {}).amount;
      else {
        if (
          activity.sourceUser.nameidentifier ===
            this.$store.getters.getUserIdentifier ||
          activity.targetUser.nameidentifier ===
            this.$store.getters.getUserIdentifier
        )
          return (activity.transaction || {}).amount;
        else return "";
      }
    },
    getActivityIcon: function (activity) {
      if (activity && activity.message) {
        // birth-day
        if (activity.message.includes("Birthday")) {
          //return "mdi-cake-layered mdi-18px";
          return "&#127874;";
        } else if (activity.message.includes("Anniversary")) {
          //return "mdi-balloon";
          return "&#127881;";
        } else if (activity.message.includes("Shared")) {
          //return "mdi-share mdi-18px";
          return "&#129309;";
        }
        //return "mdi-emoticon-excited mdi-18px";
        return "&#129395;";
      }
    },
    getActivityColor: function (activity) {
      if (activity && activity.message) {
        if (activity.message.includes("Shared")) {
          return "#e0922f";
        }
        return "#3cc0c9";
      }
    },
    getActivityImage: function (activity) {
      if (activity && activity.message) {
        if (activity.message.includes("Birthday")) {
          return "https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/Ovation-Birthday.png";
        } else if (activity.message.includes("Anniversary")) {
          return "https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/Ovation-Anniversary.png";
        }
        return "https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/Ovation-Default.png";
      }
    },
  },
  beforeMount() {
    this.loadRecentActivities();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
};
</script>

<style scoped>
.halfwhite-text {
  color: #464646 !important;
}
</style>